import React from 'react';
import { CheckCircleFilled } from '@ant-design/icons';
import { notification } from 'antd';

export const toastrError = (message = '', duration = 3, description = undefined) => {
  notification.error({
    message,
    description,
    placement: 'bottomLeft',
    duration,
  });
};

export const toastrSuccess = (message = '', duration = 3, description = undefined) => {
  notification.success({
    message,
    description,
    placement: 'bottomLeft',
    duration,
    icon: <CheckCircleFilled />,
  });
};

export const toastrInfo = (message = '', duration = 3, description = undefined) => {
  notification.info({
    message,
    description,
    placement: 'bottomLeft',
    duration,
  });
};
